var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateGame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x9C Icon / Bold/GameController"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector",
    d: "M14.25 10.125H17.25",
    stroke: "#191D23",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_2",
    d: "M6.75 10.125H9.75",
    stroke: "#191D23",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_3",
    d: "M8.25 8.625V11.625",
    stroke: "#191D23",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_4",
    d: "M16.1248 5.22186L7.8748 5.24999C6.72894 5.25217 5.62031 5.65714 4.74285 6.39408C3.86538 7.13101 3.27494 8.15298 3.0748 9.28124V9.28124L1.5373 17.1656C1.43858 17.7162 1.51832 18.2839 1.76489 18.786C2.01147 19.2881 2.41198 19.6983 2.90804 19.9568C3.40409 20.2153 3.96975 20.3086 4.52254 20.223C5.07532 20.1375 5.58633 19.8776 5.98105 19.4812V19.4812L10.0311 15L16.1248 14.9719C17.4177 14.9719 18.6577 14.4582 19.5719 13.544C20.4862 12.6298 20.9998 11.3898 20.9998 10.0969C20.9998 8.80393 20.4862 7.56396 19.5719 6.64972C18.6577 5.73548 17.4177 5.22186 16.1248 5.22186V5.22186Z",
    stroke: "#191D23",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_5",
    d: "M20.925 9.25311L22.4625 17.1656C22.5612 17.7162 22.4815 18.2839 22.2349 18.786C21.9883 19.2881 21.5878 19.6983 21.0918 19.9568C20.5957 20.2153 20.03 20.3086 19.4773 20.223C18.9245 20.1375 18.4135 19.8776 18.0187 19.4812V19.4812L13.9688 14.9812",
    stroke: "#191D23",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGame);
export default __webpack_public_path__ + "static/media/create-game.65bbeb29db2761c3afb74ccb88a4a0bb.svg";
export { ForwardRef as ReactComponent };